<div class="p-float-label number-input">
    <p-inputNumber class="p-inputnumber-sm" inputId="{{id}}" (ngModelChange)="onInput($event)" [min]="min"
                   [ngModel]="formControl['value']" [disabled]="formControl['disabled']"></p-inputNumber>
    <label *ngIf="label" [htmlFor]="id" [innerHTML]="('field.'+label) | translate"></label>
    <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                          [required]="formControl.errors?.['required']"
                          [lowerPrice]="formControl.errors?.['lowerPrice']"></app-form-input-error>
</div>
